import DashboardTwoTone from "@mui/icons-material/DashboardTwoTone";
import { useTranslation } from "react-i18next";
import PageHeader from "src/components/PageHeader";

function Dashboard() {
  const { t } = useTranslation()
  return (
    <>
      <PageHeader
        heading={t(("DASHBOARD.HEADING").toUpperCase())}
        subheading={t(("DASHBOARD.SUBHEADING").toUpperCase())}
        Icon={DashboardTwoTone}
      />
    </>
  );
}

export default Dashboard;
